const state = {
};

const getters = {
};

const actions = {
	GetResellerEntitiesWithPackages({ commit }) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.get_reseller_entities_with_packages');
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetServerPackages({ commit }) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.get_server_packages');
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetServerPackageData({ commit }, server_package_id) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.get_server_package_data', {server_package_id : server_package_id});
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	DeleteServerPackages({ commit }, delete_data) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.delete_server_packages', );
			this._vm.$axios.post(r, {
				delete_data : delete_data
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	SaveServerPackage({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.save_server_package');
			this._vm.$axios.post(r,{
				server_package_data: payload
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve();
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetPackages({ commit }) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.get_packages');
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetPackageData({ commit }, package_id) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.get_package_data', {package_id : package_id});
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	SavePackage({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.save_package');
			this._vm.$axios.post(r,{
				package_data: payload
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve();
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	DeletePackages({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.delete_packages');
			this._vm.$axios.post(r,{
				packages: payload
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve();
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetAccounts({ commit }) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.get_accounts');
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetAccountData({ commit }, account_id) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.get_account_data', {account_id : account_id});
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetDataForDeleteAccounts({ commit }, accounts) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.get_data_for_delete_accounts');
			this._vm.$axios.post(r,{
				accounts: accounts
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	SaveAccountPackage({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.save_account_package');
			this._vm.$axios.post(r,{
				account_data: payload
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve();
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	DeleteAccounts({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('ccsreseller.delete_accounts');
			this._vm.$axios.post(r,{
				accounts: payload
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve();
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},
};

const mutations = {
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
